import { render, staticRenderFns } from "./GroupCard.vue?vue&type=template&id=529bc5e8&"
import script from "./GroupCard.vue?vue&type=script&lang=js&"
export * from "./GroupCard.vue?vue&type=script&lang=js&"
import style0 from "./GroupCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports